/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { DAYS, MONTHS, YEARS } from '../enums/DurationUnits.mjs'

export type FormattedDurationProps = {
  unit: 'years' | 'months' | 'days'
  value: number
}

function FormattedDuration (props: FormattedDurationProps) {
  const { unit, value } = props
  const intl = useIntl()

  if (unit === YEARS) {
    return intl.formatMessage({
      id: '%_years',
      defaultMessage: '{number, plural, one {# année} other {# années}}'
    }, { number: value })
  }
  if (unit === MONTHS) {
    return intl.formatMessage({
      id: '%_months',
      defaultMessage: '{number, plural, one {# mois} other {# mois}}'
    }, { number: value })
  }
  if (unit === DAYS) {
    return intl.formatMessage({
      id: '%_days',
      defaultMessage: '{number, plural, one {# jour} other {# jours}}'
    }, { number: value })
  }
  return `${value} ?`
}

export default FormattedDuration
